/**
 * The various major z-index layers, adjust with caution and leave space between to add to later.
 */
export const Layers = {
    HEADER: 100,
    Modal: 1000,
};
